import { Controller } from "@hotwired/stimulus";
import Channel from "src/channel";

import { partnerPortalCable } from "src/partner_cable";

class MissingTaskId extends Error {
  constructor() {
    super("Can't read taskID from DOM");
  }
}

export default class ReportController extends Controller {
  static targets = ["status", "progress", "progressBar"];

  declare statusTarget: HTMLSpanElement;
  declare progressTarget: HTMLSpanElement;
  declare progressBarTarget: HTMLProgressElement;

  connect(): void {
    const taskId = this.data.get("id");
    if (taskId === null) {
      throw new MissingTaskId();
    }

    const channel = new Channel(
      partnerPortalCable(),
      "BackgroundTasksChannel",
      {
        background_task_id: taskId,
      },
    );

    channel.on("connected", ({ channel }): void => {
      channel.perform("force_update");
    });

    channel.on("received", (params): void => {
      const data = ensureKey("data", params);
      const status: string = ensureKey("status", data);

      if (status == "Finished") {
        window.location.reload();
        return;
      }

      const progress: number = ensureKey("progress", data);

      if (progress < 0) {
        this.progressBarTarget.removeAttribute("value");
        this.progressTarget.innerText = "unknown";
      } else {
        this.progressTarget.innerText = progress.toString();
        this.progressBarTarget.setAttribute("value", progress.toString());
      }

      this.statusTarget.innerText = status;
    });
  }
}

function ensureKey<T>(keyName: string, data: unknown): T {
  if (!data || typeof data !== "object" || !(keyName in data)) {
    throw new Error("Invalid data");
  }

  return (data as Record<string, unknown>)[keyName] as T;
}
